import { z } from 'zod';
import { get, post } from '../http';
import { type ListQuery, paginated, resource } from '../schemas/common';
import { transactionSchema, walletKindSchema, walletSchema } from '../schemas/domain';

export const transferInput = z.object({
  to_user_code: z.string().min(3, 'Enter the recipient User ID'),
  amount_usd: z.coerce.number().positive('Amount must be greater than zero'),
  from_wallet: walletKindSchema.default('income'),
  transaction_pin: z.string().min(4, 'Transaction PIN required'),
  note: z.string().max(200).optional(),
});
export type TransferInput = z.infer<typeof transferInput>;

export interface TransactionQuery extends ListQuery {
  wallet?: 'activation' | 'income';
  /**
   * Credit/debit filter. Named `flow` rather than `direction` because
   * ListQuery already uses `direction` for the sort order.
   */
  flow?: 'credit' | 'debit';
}

export const walletApi = {
  balances: () => get('/wallet', resource(walletSchema)),

  transactions: (query: TransactionQuery = {}) =>
    get('/wallet/transactions', paginated(transactionSchema), query),

  transfer: (input: TransferInput) => post('/wallet/transfer', resource(transactionSchema), input),

  /** Confirms a transfer recipient before the user commits. */
  lookupRecipient: (userCode: string) =>
    get('/wallet/transfer/lookup', resource(z.object({ user_code: z.string(), name: z.string() })), {
      user_code: userCode,
    }),
};
